/**
 * Shared layout for public legal pages (Impressum / Datenschutz).
 * - Same Novatus-dark visual language as the rest of the app, but
 *   intentionally lighter chrome (no auth-gating, no nav, just a
 *   back link + branding).
 * - Lets us reuse styles without polluting the protected Layout.
 */
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const LegalLayout = ({ title, subtitle, children, "data-testid": testId }) => (
  <div className="min-h-screen bg-novatus-bg text-novatus-text-1" data-testid={testId}>
    <header className="border-b border-novatus">
      <div className="max-w-4xl mx-auto px-4 sm:px-8 py-4 flex items-center justify-between gap-4">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-novatus-text-2 hover:text-novatus-green transition-colors"
          data-testid="legal-back-link"
        >
          <ArrowLeft className="w-4 h-4" />
          Zurück
        </Link>
        <Link to="/" className="inline-flex items-center gap-2" data-testid="legal-brand">
          <span className="font-display font-black text-white text-lg tracking-tight">NOVATUS</span>
          <span className="font-display font-black text-novatus-green text-lg tracking-tight">Energie</span>
        </Link>
      </div>
    </header>

    <main className="max-w-4xl mx-auto px-4 sm:px-8 py-10 sm:py-16">
      <p className="label-eyebrow text-novatus-green">Rechtliche Hinweise</p>
      <h1 className="font-display font-black text-3xl sm:text-5xl text-white mt-2 leading-tight">{title}</h1>
      {subtitle && <p className="text-novatus-text-2 mt-3 text-base sm:text-lg">{subtitle}</p>}
      <div className="mt-10 prose-legal">{children}</div>
    </main>

    <footer className="border-t border-novatus mt-16 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-8 flex flex-wrap items-center justify-between gap-3 text-xs text-novatus-text-3">
        <span>© {new Date().getFullYear()} NOVATUS Energie GmbH</span>
        <div className="flex gap-4">
          <Link to="/impressum" className="hover:text-novatus-green transition-colors" data-testid="legal-footer-impressum">Impressum</Link>
          <Link to="/datenschutz" className="hover:text-novatus-green transition-colors" data-testid="legal-footer-datenschutz">Datenschutz</Link>
          <Link to="/agb" className="hover:text-novatus-green transition-colors" data-testid="legal-footer-agb">AGB</Link>
          <Link to="/widerruf" className="hover:text-novatus-green transition-colors" data-testid="legal-footer-widerruf">Widerruf</Link>
        </div>
      </div>
    </footer>
  </div>
);

export default LegalLayout;
